// Hitori generator & validator
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function whitesConnected(black, n) {
  let start = null, total = 0;
  for (let r = 0; r < n; r++)
    for (let c = 0; c < n; c++)
      if (!black[r][c]) { total++; if (!start) start = [r, c]; }
  if (!start) return false;
  const seen = new Set([`${start[0]},${start[1]}`]);
  const stack = [start];
  while (stack.length) {
    const [r, c] = stack.pop();
    for (const [dr, dc] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) {
      const nr = r + dr, nc = c + dc;
      if (nr < 0 || nc < 0 || nr >= n || nc >= n) continue;
      if (black[nr][nc]) continue;
      const k = `${nr},${nc}`;
      if (!seen.has(k)) { seen.add(k); stack.push([nr, nc]); }
    }
  }
  return seen.size === total;
}

function adjBlack(black, r, c, n) {
  for (const [dr, dc] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) {
    const nr = r + dr, nc = c + dc;
    if (nr >= 0 && nc >= 0 && nr < n && nc < n && black[nr][nc]) return true;
  }
  return false;
}

export function makeHitori(n) {
  const val = Array.from({ length: n }, (_, r) => Array.from({ length: n }, (_, c) => ((r + c) % n) + 1));
  const black = Array.from({ length: n }, () => Array(n).fill(false));
  const target = Math.floor(n * n * 0.18);
  let count = 0;
  for (const idx of shuffle([...Array(n * n).keys()])) {
    if (count >= target) break;
    const r = Math.floor(idx / n), c = idx % n;
    if (adjBlack(black, r, c, n)) continue;
    black[r][c] = true;
    if (!whitesConnected(black, n)) { black[r][c] = false; continue; }
    count++;
  }
  for (let r = 0; r < n; r++)
    for (let c = 0; c < n; c++) {
      if (!black[r][c]) continue;
      const rowW = [];
      for (let cc = 0; cc < n; cc++) if (!black[r][cc]) rowW.push(cc);
      if (rowW.length) val[r][c] = val[r][rowW[Math.floor(Math.random() * rowW.length)]];
      else {
        const colW = [];
        for (let rr = 0; rr < n; rr++) if (!black[rr][c]) colW.push(rr);
        if (colW.length) val[r][c] = val[colW[Math.floor(Math.random() * colW.length)]][c];
      }
    }
  return { n, val, solution: black };
}

export function hitoriConflicts(shaded, val, n) {
  const bad = new Set();
  for (let r = 0; r < n; r++)
    for (let c = 0; c < n; c++) {
      if (!shaded[r][c]) continue;
      for (const [dr, dc] of [[1, 0], [0, 1]]) {
        const nr = r + dr, nc = c + dc;
        if (nr < n && nc < n && shaded[nr][nc]) { bad.add(`${r},${c}`); bad.add(`${nr},${nc}`); }
      }
    }
  for (let r = 0; r < n; r++) {
    const seen = {};
    for (let c = 0; c < n; c++) if (!shaded[r][c]) (seen[val[r][c]] = seen[val[r][c]] || []).push(c);
    for (const v in seen) if (seen[v].length > 1) seen[v].forEach((c) => bad.add(`${r},${c}`));
  }
  for (let c = 0; c < n; c++) {
    const seen = {};
    for (let r = 0; r < n; r++) if (!shaded[r][c]) (seen[val[r][c]] = seen[val[r][c]] || []).push(r);
    for (const v in seen) if (seen[v].length > 1) seen[v].forEach((r) => bad.add(`${r},${c}`));
  }
  return bad;
}

export function hitoriWin(shaded, val, n) {
  if (hitoriConflicts(shaded, val, n).size > 0) return false;
  return whitesConnected(shaded, n);
}
